import React, { useContext } from "react";
import classNames from "classnames";

import Overlay from "../overlay/OverlayController.jsx";
import Field from "../../atoms/field/Field.jsx";
import Button from "../button/ButtonController.jsx";
import { useIntl, FormattedMessage } from "react-intl";

export default function Login(props) {
  const {
    customer,
    className,
    active,
    data,
    errors,
    onLoginButtonClick,
    onChange,
    onSubmit,
    ...rest
  } = props;
  const { message } = errors;
  const intl = useIntl();
  return (
    <Overlay
      className={classNames("login", className)}
      active={active}
      {...rest}
    >
      <div className="login__text">
        {" "}
        <FormattedMessage id="enterPsw" />{" "}
      </div>
      <form onSubmit={onSubmit}>
        {message && <div className="field__error">{message}</div>}
        <Field
          name="password"
          type="password"
          label={intl.formatMessage({ id: "password" })}
          data={data}
          errors={errors}
          onChange={onChange}
        />
        <a
          rel="noreferrer"
          target="_blank"
          href={`/password_reset?email=${customer.email}`}
        >
          <FormattedMessage id="forgotPsw" />
        </a>
        <Button className="login__button" onClick={onLoginButtonClick}>
          Login
        </Button>
      </form>
    </Overlay>
  );
}
